module.exports = __webpack_public_path__ + "static/54fc2b815127daa9e060d4b4a69e527dd4edad3fd61de07a20fae4362b205592-757249972491744b42940bde904e3c5b.jpeg";